<template>
  <div class="app-container">
    <div class="filter-container">
      <el-row type="flex" justify="end" align="middle" :gutter="10"> </el-row>

      <el-input
        v-model="listQuery.username"
        placeholder="请输入用户名称"
        style="width: 200px"
        class="filter-item"
        clearable
      />

      <el-input
        v-model="listQuery.last_name"
        placeholder="请输入姓"
        class="filter-item"
        style="width: 200px"
        clearable
      />

      <el-input
        v-model="listQuery.first_name"
        placeholder="请输入名"
        class="filter-item"
        style="width: 200px"
        clearable
      />

      <el-input
        v-model="listQuery.uuid"
        placeholder="请输入UUID"
        style="width: 200px"
        class="filter-item"
        clearable
      />

      <el-input
        v-model="listQuery.user_id"
        placeholder="请输入会员ID"
        class="filter-item"
        style="width: 200px"
        clearable
      />

      <el-select
        v-model="listQuery.vip_product_id"
        placeholder="会员权益"
        clearable
        style="width: 200px"
        class="filter-item"
      >
        <el-option
          v-for="item in vipProductList"
          :key="item.value"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>

      <el-select
        v-model="listQuery.vip_status"
        placeholder="活跃状态"
        clearable
        class="filter-item"
        style="width: 200px"
      >
        <el-option label="VIP已激活" value="active" />
        <el-option label="VIP未激活" value="inactive" />
        <el-option label="VIP未激活-网红" value="inactive_affiliate" />
        <el-option label="非VIP" value="never_purchased" />
      </el-select>

      <el-select
        v-model="listQuery.is_normal"
        placeholder="状态"
        clearable
        style="width: 200px"
        class="filter-item"
      >
        <el-option label="正常" value="1" />
        <el-option label="已冻结" value="0" />
      </el-select>
      <!-- <el-select
        v-model="listQuery.is_limit"
        placeholder="是否已满600"
        clearable
        style="width: 200px"
        class="filter-item"
      >
        <el-option label="已满" value="1" />
        <el-option label="未满" value="0" />
      </el-select> -->
      <!-- <el-select
        v-model="listQuery.is_submit"
        placeholder="是否提交1099"
        clearable
        style="width: 200px"
        class="filter-item"
      >
        <el-option label="已提交" value="1" />
        <el-option label="未提交" value="0" />
      </el-select> -->
      <el-select
        v-model="listQuery.vip_level_no"
        placeholder="会员等级"
        clearable
        class="filter-item"
        style="width: 200px"
      >
        <el-option
          v-for="config in levelList"
          :label="config.name"
          :value="config.level_no"
          :key="config.level_no"
        />
      </el-select>

      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索
      </el-button>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      :row-class-name="tableRowClassName"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="会员ID" width="120">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="UUID" width="120">
        <template slot-scope="scope">
          {{ scope.row.uuid }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="用户名称" width="120">
        <template slot-scope="scope">
          {{ scope.row.username || '' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="邮箱" min-width="180">
        <template slot-scope="scope">
          {{ scope.row.email ? scope.row.email : '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="加入时间" min-width="180">
        <template slot-scope="scope">
          {{ scope.row.created_at ? scope.row.created_at : '-' }}
        </template>
      </el-table-column>
      <el-table-column label="名" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.first_name ? scope.row.first_name : '-' }}
        </template>
      </el-table-column>
      <el-table-column label="姓" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.last_name ? scope.row.last_name : '-' }}
        </template>
      </el-table-column>

      <!-- <el-table-column label="邀请码" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.invite_code || '-' }}
        </template>
      </el-table-column> -->
      <el-table-column label="公司" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.company ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column label="联系方式" min-width="150" align="center">
        <template slot-scope="scope">
          {{ scope.row.contact ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="地址" min-width="200">
        <template slot-scope="scope">
          {{ scope.row.address || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="推荐人ID" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.team.parent?.uuid ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column label="累计奖励金" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.commission ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column
        label="会员有效期（点数）"
        min-width="110"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.vip_point }}
        </template>
      </el-table-column>
      <el-table-column label="银行收款信息" min-width="280" align="center">
        <template slot-scope="scope">
          <el-tooltip
            effect="dark"
            placement="top"
            v-if="
              scope.row.bank_payment_info &&
              scope.row.bank_payment_info.length > 0
            "
          >
            <div
              style="
                max-height: 40px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                cursor: pointer;
              "
            >
              {{ scope.row.bank_payment_info }}
            </div>
            <div slot="content" style="width: 400px">
              {{ scope.row.bank_payment_info }}
            </div>
          </el-tooltip>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="会员权益" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="primary"
            >{{ scope.row.vip_product_name ?? '-' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="会员等级" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="primary">{{ scope.row.team.vip_level_name }} </el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column label="可获得奖励代数" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.vip_can_receive_reward_gene_num ?? '-' }}
        </template>
      </el-table-column> -->
      <el-table-column label="奖励代数" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.vip_distribution_reward_gene_num ?? '-' }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="是否提交1099" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.is_submit == 1 ? 'success' : 'warning'"
            >{{ scope.row.is_submit == 1 ? '已提交' : '未提交' }}
          </el-tag>
        </template>
      </el-table-column> -->
      <el-table-column align="center" label="活跃状态" min-width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.vip_status === 'active'" type="success"
            >VIP已激活
          </el-tag>
          <el-tag v-else-if="scope.row.vip_status === 'inactive'" type="warning"
            >VIP未激活
          </el-tag>
          <el-tag
            v-else-if="scope.row.vip_status === 'inactive_affiliate'"
            type="primary"
            >VIP未激活-网红
          </el-tag>
          <el-tag
            v-else-if="scope.row.vip_status === 'never_purchased'"
            type="danger"
            >非VIP
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="冻结状态" min-width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_normal == '1'" type="success">正常</el-tag>
          <el-tag v-else-if="scope.row.is_normal == '0'" type="warning"
            >已冻结
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="230"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <!-- <el-button
            v-if="scope.row.commission >= 600 && scope.row.is_submit == 0"
            size="mini"
            type="primary"
            @click="changeIsSubmit(scope.row)"
          >
            提交1099
          </el-button> -->
          <el-button size="mini" type="warning" @click="edit(scope.row)">
            编辑会员信息
          </el-button>
          <div style="margin-top: 5px">
            <el-button size="mini" type="primary" @click="totree(scope.row)">
              团队结构
            </el-button>
            <el-button
              size="mini"
              type="primary"
              @click="changeStatus(scope.row)"
            >
              {{ scope.row.is_normal == 1 ? '冻结' : '解冻' }}
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      title="驳回"
      :visible.sync="rejectModalVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      append-to-body
      width="512px"
    >
      <el-form
        ref="rejectForm"
        :model="rejectForm"
        :rules="rejectRules"
        label-width="0px"
      >
        <el-form-item prop="reason">
          <el-input
            type="textarea"
            placeholder="驳回理由"
            :rows="4"
            v-model="rejectForm.reason"
          ></el-input>
        </el-form-item>
        <el-row type="flex" justify="end">
          <el-button @click="rejectModalVisible = false">取消</el-button>
          <el-button type="primary" @click="reject('rejectForm')"
            >确认
          </el-button>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      rejectModalVisible: false,
      rejectRules: {
        reason: [
          { required: true, message: '请填写驳回理由', trigger: 'blur' },
        ],
      },
      rejectForm: {
        id: '',
        reason: '',
      },
      list: null,
      total: null,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        user_id: '',
        last_name: '',
        first_name: '',
        email: '',
        phone: '',
        is_normal: '',
        is_vip: '1',
      },
      levelList: [],
      vipProductList: [],
    }
  },
  created() {
    this.getVipProduct()
    this.getLevelList()
    this.getList()
  },
  watch: {
    rejectModalVisible() {
      this.rejectForm = {
        ...this.rejectForm,
        reason: '',
      }
    },
  },
  methods: {
    changeIsSubmit(row) {
      this.$confirm('是否提交1099', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/users/changeIsSubmit',
            method: 'post',
            data: {
              id: row.id,
              operate: 1,
            },
          }).then((res) => {
            console.log(res)
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    tableRowClassName({ row, rowIndex }) {
      if (Number(row.commission) < 600) {
        return ''
      } else {
        return 'success-row'
      }
    },
    getVipProduct() {
      request({
        url: '/api/backend/vipProduct/list',
        method: 'get',
      }).then((response) => {
        this.vipProductList = response.data.data
      })
    },
    totree(row) {
      this.$router.push('/member/teamtree?id=' + row.uuid)
    },
    changeStatus(row) {
      let str
      if (row.is_normal == 1) {
        str = '此操作将冻结该用户, 是否继续?'
      } else {
        str = '此操作将解冻该用户, 是否继续?'
      }
      this.$confirm(str, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/users/forbid',
            method: 'post',
            data: {
              id: row.id,
              operate: row.is_normal == 1 ? 0 : 1,
            },
          }).then((res) => {
            console.log(res)
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    getLevelList() {
      request({
        url: '/api/backend/vipLevelConfig/list',
        method: 'get',
        params: {},
      }).then((response) => {
        this.levelList = response.data
      })
    },
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/users',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total
        this.listLoading = false
        this.$forceUpdate()
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    edit(val) {
      this.$router.push('/member/editmemberinfo?id=' + val.id)
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
::v-deep .el-table .warning-row {
  background: oldlace;
}

::v-deep .el-table .success-row {
  background: #4cd798;
}
</style>
